module.exports = __webpack_public_path__ + "static/media/room-8.542e0651.jpg";